import React__default from 'react';
import HighlightPreferredStoreContainer from '../../components/HighlightPreferredStore/HighlightPreferredStoreContainer.js';
import StoreFinderContainer from '../../components/StoreFinder/StoreFinderContainer.js';
import { StoreFinderProvider } from '../../context/StoreFinder/provider.js';

const StoresRoot = ({ urls , googleMapsId , hidePhone , hideEmail , storeSearchFilters , stores ,  })=>{
    return /*#__PURE__*/ React__default.createElement(StoreFinderProvider, {
        googleMapsId: googleMapsId,
        withUrlParams: true,
        hidePhone: hidePhone,
        hideEmail: hideEmail,
        initialStores: stores,
        urls: urls
    }, /*#__PURE__*/ React__default.createElement("style", {
        jsx: true,
        global: true
    }, `
        .banner,
        .notification-bar {
          position: relative;
          z-index: 100;
        }
      `), /*#__PURE__*/ React__default.createElement(StoreFinderContainer, {
        highlightPreferredStore: /*#__PURE__*/ React__default.createElement(HighlightPreferredStoreContainer, null),
        storeSearchFilters: storeSearchFilters,
        showAttributesAsTags: true
    }));
};
var StoresRoot$1 = StoresRoot;

export { StoresRoot$1 as default };
//# sourceMappingURL=StoresRoot.js.map
